var _circle, _circle2, _path, _path2, _path3, _path4, _rect, _rect2, _circle3, _circle4, _circle5, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoVerificationPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 132,
    viewBox: "0 0 134 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9604,
    cy: 60.9292,
    r: 60.7768,
    fill: "#F5F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9603,
    cy: 60.9291,
    r: 47.2709,
    fill: "#E4ECFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.2126 101.601H32.8388C31.3724 101.601 30.1836 100.412 30.1836 98.9454V22.8075C30.1836 21.3411 31.3724 20.1523 32.8388 20.1523H76.8562L91.8678 34.0092V98.9454C91.8678 100.412 90.679 101.601 89.2126 101.601Z",
    fill: "#F5F8FF",
    stroke: "#C3D0EB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9688 37.1752C36.9688 36.1659 37.787 35.3477 38.7963 35.3477H74.1831C75.1925 35.3477 76.0107 36.1659 76.0107 37.1752C76.0107 38.1846 75.1925 39.0028 74.1831 39.0028H38.7963C37.787 39.0028 36.9688 38.1846 36.9688 37.1752ZM36.9688 48.4401C36.9688 47.4308 37.787 46.6126 38.7963 46.6126H84.4567C85.4661 46.6126 86.2843 47.4308 86.2843 48.4401C86.2843 49.4495 85.4661 50.2677 84.4567 50.2677H38.7963C37.787 50.2677 36.9688 49.4495 36.9688 48.4401ZM36.9688 59.705C36.9688 58.6957 37.787 57.8774 38.7963 57.8774H51.3529C52.3623 57.8774 53.1805 58.6957 53.1805 59.705C53.1805 60.7144 52.3623 61.5326 51.3529 61.5326H38.7963C37.787 61.5326 36.9688 60.7144 36.9688 59.705ZM57.5159 59.705C57.5159 58.6957 58.3342 57.8774 59.3435 57.8774H84.4567C85.4661 57.8774 86.2843 58.6957 86.2843 59.705C86.2843 60.7144 85.4661 61.5326 84.4567 61.5326H59.3435C58.3342 61.5326 57.5159 60.7144 57.5159 59.705ZM36.9688 70.9699C36.9688 69.9606 37.787 69.1423 38.7963 69.1423H71.9001C72.9095 69.1423 73.7277 69.9606 73.7277 70.9699C73.7277 71.9793 72.9095 72.7975 71.9001 72.7975H38.7963C37.787 72.7975 36.9688 71.9793 36.9688 70.9699ZM78.0631 70.9699C78.0631 69.9606 78.8813 69.1423 79.8907 69.1423H84.4567C85.4661 69.1423 86.2843 69.9606 86.2843 70.9699C86.2843 71.9793 85.4661 72.7975 84.4567 72.7975H79.8907C78.8813 72.7975 78.0631 71.9793 78.0631 70.9699ZM36.9688 81.1083C36.9688 80.099 37.787 79.2808 38.7963 79.2808H81.0322C82.0415 79.2808 82.8598 80.099 82.8598 81.1083C82.8598 82.1177 82.0415 82.9359 81.0322 82.9359H38.7963C37.787 82.9359 36.9688 82.1177 36.9688 81.1083ZM36.9688 91.2467C36.9688 90.2374 37.787 89.4192 38.7963 89.4192H69.6171C70.6264 89.4192 71.4447 90.2374 71.4447 91.2467C71.4447 92.2561 70.6264 93.0743 69.6171 93.0743H38.7963C37.787 93.0743 36.9688 92.2561 36.9688 91.2467Z",
    fill: "#C3D0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9688 37.1752C36.9688 36.1659 37.787 35.3477 38.7963 35.3477H74.1831C75.1925 35.3477 76.0107 36.1659 76.0107 37.1752C76.0107 38.1846 75.1925 39.0028 74.1831 39.0028H38.7963C37.787 39.0028 36.9688 38.1846 36.9688 37.1752Z",
    fill: "#0071BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2471 19.1523L92.8677 33.5714H81.2471C79.0379 33.5714 77.2471 31.7805 77.2471 29.5714V19.1523Z",
    fill: "#C3D0EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.7292,
    height: 2.53951,
    rx: 1.26976,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 20.5986 21.1523)",
    fill: "#0071BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.7292,
    height: 2.53951,
    rx: 1.26976,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 10.1836 22.9473)",
    fill: "#0071BC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5248,
    cy: 56.4935,
    r: 4.3412,
    stroke: "#2D94D8",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.791,
    cy: 69.7601,
    r: 3.60776,
    stroke: "#0071BC",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2937,
    cy: 77.2624,
    r: 1.11008,
    stroke: "#4F86FF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.098 124.111C84.9701 124.111 102.701 123.075 102.701 121.798C102.701 120.522 84.9701 119.486 63.098 119.486C41.2259 119.486 23.4951 120.522 23.4951 121.798C23.4951 123.075 41.2259 124.111 63.098 124.111Z",
    fill: "#C3D0EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9227 87.9309L89.8732 81.9803L114.394 102.909C117.397 105.473 117.578 110.052 114.786 112.844C111.994 115.635 107.415 115.455 104.852 112.452L83.9227 87.9309Z",
    fill: "#1A3166"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1475 92.8819L104.852 112.453C107.415 115.456 111.994 115.637 114.786 112.845C117.578 110.053 117.397 105.474 114.394 102.91L92.547 84.2637C91.6679 87.4332 90.1548 90.3511 88.1475 92.8819Z",
    fill: "#0071BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1286 52.224L61.748 87.9322C61.5111 87.7489 61.2764 87.5592 61.046 87.3672C59.5594 86.1101 58.2648 84.633 57.2051 82.9849L70.4902 52.1411C72.6912 51.7787 74.9369 51.8067 77.1286 52.224Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0627 58.4189L73.6018 91.9916C70.5981 91.9949 67.6339 91.2919 64.9385 89.9368L80.7287 53.2754C83.5261 54.3938 86.0352 56.1534 88.0627 58.4189Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8101 57.1602C62.0099 58.9827 59.7918 61.6195 58.4456 64.7446C57.0992 67.8703 56.6885 71.3377 57.2685 74.7061C57.8485 78.0742 59.3912 81.1829 61.6924 83.6419C63.993 86.1001 66.9475 87.7982 70.1782 88.5315C73.4085 89.2647 76.7791 89.0028 79.8666 87.7766L79.8669 87.7765C81.9179 86.9622 83.7959 85.7413 85.3921 84.1803C86.9885 82.6193 88.2717 80.7487 89.1655 78.6737C90.0594 76.5987 90.5455 74.3617 90.5944 72.091C90.6433 69.8203 90.2541 67.5632 89.4502 65.4492L89.4501 65.449C88.2398 62.265 86.1368 59.5293 83.4167 57.5812C80.6973 55.6337 77.481 54.5586 74.1745 54.4839C70.8681 54.4093 67.6095 55.3382 64.8101 57.1602ZM53.2711 62.5156C55.0509 58.3838 57.9937 54.8742 61.7367 52.4381C65.4804 50.0014 69.8533 48.7507 74.3017 48.8512C78.7501 48.9516 83.0637 50.3984 86.6972 53.0006C90.33 55.6023 93.1174 59.2399 94.7166 63.4469C95.7789 66.2406 96.2918 69.2189 96.2273 72.2124C96.1628 75.206 95.522 78.1588 94.3401 80.9027C93.158 83.6468 91.4571 86.1299 89.3313 88.2086C87.2056 90.2874 84.6966 91.921 81.9462 93.013C77.8034 94.6582 73.2732 95.0115 68.9311 94.026C64.5895 93.0406 60.6402 90.7631 57.5787 87.4918C54.5178 84.2211 52.4807 80.1034 51.716 75.6622C50.9513 71.2212 51.4914 66.647 53.2711 62.5156Z",
    fill: "#0071BC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.8004,
    height: 2.20696,
    rx: 1.10348,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 111.234 37.1523)",
    fill: "#2D94D8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.8004,
    height: 2.20696,
    rx: 1.10348,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 102.184 38.7129)",
    fill: "#2D94D8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.8561,
    height: 1.87174,
    rx: 0.935869,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 44.8604 107.152)",
    fill: "#0071BC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.8561,
    height: 1.87174,
    rx: 0.935869,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 37.1836 108.477)",
    fill: "#0071BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVerificationPlaceholder);
export default __webpack_public_path__ + "static/media/noVerificationPlaceholder.9d1351b2315255a81b15e1ed14b08ced.svg";
export { ForwardRef as ReactComponent };